// src/const/common.js

// API URL (выбирай нужный)
export const url = `${process.env.REACT_APP_API_URL}api`;

// export const url = 'https://dentallab.na4u.ru';
// export const url = 'http://dentalapi.ru';

// Многоязычные тексты
export const texts = {
    en: {
        files: 'Files',
        orders: 'Orders',
        debt: 'Debt',
        currency: 'RUB',
        lab: 'Laboratory',
        orderNumber: 'Order No.',
        dentist: 'Dentist: ',
        clinic: 'Clinic: ',
        rub: 'RUB',
        paid: 'Paid',
        all: 'All',
        patientLabel: 'Patient',
        colorLabel: 'Color:',
        deliveryDateLabel: 'Delivery Date:',
        costLabel: 'Cost:',
        dentistLabel: 'Dentist',
        enterPatientName: 'Enter patient name...',
        deliveryDate: 'Delivery Date:',
        color: 'Color:',
        technician: 'Technician',
        cost: 'Cost:',
        paymentMethod: 'Payment Method',
        cash: 'Cash',
        nonCash: 'Non-Cash',
        photo: 'Photo',
        audio: 'Audio',
        comments: 'Comments',
        settings: 'Settings',
        work: 'Work',
        statistics: 'Statistics',
        diary: 'Diary',
        price: 'Price',
        Act: 'Acceptance',
        filters: 'Filters',
        period: 'Period',
        salary: 'Salary',
        priceLabel: 'Price',
        doctor: 'Dentist',
        next: 'Next',
        back: 'Back',
        week: 'Week',
        save: 'Save',
        language: 'Language',
        company: 'Company',
        cooperation: 'Cooperation'
    },
    ru: {
        files: 'Файлы',
        orders: 'Заказы',
        debt: 'Долг',
        currency: 'руб.',
        lab: 'Лаборатория',
        orderNumber: 'Заказ №',
        dentist: 'Стоматолог: ',
        clinic: 'Клиника: ',
        rub: 'руб',
        paid: 'Оплачен',
        all: 'Все',
        patientLabel: 'Пациент',
        colorLabel: 'Цвет:',
        deliveryDateLabel: 'Дата сдачи:',
        costLabel: 'Стоимость:',
        dentistLabel: 'Стоматолог',
        enterPatientName: 'Введите фио пациента...',
        deliveryDate: 'Дата сдачи:',
        color: 'Цвет:',
        technician: 'Техник',
        cost: 'Стоимость:',
        paymentMethod: 'Способ оплаты',
        cash: 'Наличные',
        nonCash: 'Безналичные',
        photo: 'Фото',
        audio: 'Аудио',
        comments: 'Комментарии',
        settings: 'Настройки',
        work: 'Работа',
        statistics: 'Статистика',
        diary: 'Ежедневник',
        price: 'Прайс',
        Act: 'Акт',
        filters: 'Фильтры',
        period: 'Период',
        salary: 'Зарплата',
        priceLabel: 'Цена',
        doctor: 'Врач',
        next: 'Далее',
        back: 'Назад',
        week: 'Неделя',
        save: 'Сохранить',
        language: 'Язык',
        company: 'Компания',
        cooperation: 'Сотрудничество'
    },
    zh: {
        files: '文件',
        orders: '订单',
        debt: '欠款',
        currency: '卢布',
        lab: '实验室',
        orderNumber: '订单号',
        dentist: '牙医：',
        clinic: '诊所：',
        rub: '卢布',
        paid: '已支付',
        all: '全部',
        patientLabel: '患者',
        colorLabel: '颜色：',
        deliveryDateLabel: '交付日期：',
        costLabel: '费用：',
        dentistLabel: '牙医',
        enterPatientName: '输入患者姓名...',
        deliveryDate: '交付日期：',
        color: '颜色：',
        technician: '技师',
        cost: '费用：',
        paymentMethod: '支付方式',
        cash: '现金',
        nonCash: '转账',
        photo: '照片',
        audio: '音频',
        comments: '备注',
        settings: '设置',
        work: '工作',
        statistics: '统计',
        diary: '日记',
        price: '价格表',
        Act: '验收单',
        filters: '筛选',
        period: '周期',
        salary: '工资',
        priceLabel: '价格',
        doctor: '医生',
        next: '下一步',
        back: '返回',
        week: '周',
        save: '保存',
        language: '语言',
        company: '公司',
        cooperation: '合作'
    },
    pt: {
        files: 'Arquivos',
        orders: 'Pedidos',
        debt: 'Dívida',
        currency: 'RUB',
        lab: 'Laboratório',
        orderNumber: 'Pedido nº',
        dentist: 'Dentista: ',
        clinic: 'Clínica: ',
        rub: 'RUB',
        paid: 'Pago',
        all: 'Todos',
        patientLabel: 'Paciente',
        colorLabel: 'Cor:',
        deliveryDateLabel: 'Data de entrega:',
        costLabel: 'Custo:',
        dentistLabel: 'Dentista',
        enterPatientName: 'Digite o nome do paciente...',
        deliveryDate: 'Data de entrega:',
        color: 'Cor:',
        technician: 'Técnico',
        cost: 'Custo:',
        paymentMethod: 'Método de pagamento',
        cash: 'Dinheiro',
        nonCash: 'Cartão/Transferência',
        photo: 'Foto',
        audio: 'Áudio',
        comments: 'Comentários',
        settings: 'Configurações',
        work: 'Trabalho',
        statistics: 'Estatísticas',
        diary: 'Diário',
        price: 'Preço',
        Act: 'Aceitação',
        filters: 'Filtros',
        period: 'Período',
        salary: 'Salário',
        priceLabel: 'Preço',
        doctor: 'Dentista',
        next: 'Próximo',
        back: 'Voltar',
        week: 'Semana',
        save: 'Salvar',
        language: 'Idioma',
        company: 'Empresa',
        cooperation: 'Cooperação'
    },
    es: {
        files: 'Archivos',
        orders: 'Pedidos',
        debt: 'Deuda',
        currency: 'RUB',
        lab: 'Laboratorio',
        orderNumber: 'Pedido nº',
        dentist: 'Dentista: ',
        clinic: 'Clínica: ',
        rub: 'RUB',
        paid: 'Pagado',
        all: 'Todos',
        patientLabel: 'Paciente',
        colorLabel: 'Color:',
        deliveryDateLabel: 'Fecha de entrega:',
        costLabel: 'Costo:',
        dentistLabel: 'Dentista',
        enterPatientName: 'Ingrese el nombre del paciente...',
        deliveryDate: 'Fecha de entrega:',
        color: 'Color:',
        technician: 'Técnico',
        cost: 'Costo:',
        paymentMethod: 'Método de pago',
        cash: 'Efectivo',
        nonCash: 'Tarjeta/Transferencia',
        photo: 'Foto',
        audio: 'Audio',
        comments: 'Comentarios',
        settings: 'Configuraciones',
        work: 'Trabajo',
        statistics: 'Estadísticas',
        diary: 'Diario',
        price: 'Precio',
        Act: 'Aceptación',
        filters: 'Filtros',
        period: 'Período',
        salary: 'Salario',
        priceLabel: 'Precio',
        doctor: 'Dentista',
        next: 'Siguiente',
        back: 'Atrás',
        week: 'Semana',
        save: 'Guardar',
        language: 'Idioma',
        company: 'Empresa',
        cooperation: 'Cooperación'
    }
};
